import * as events from '../../../events';
import { makeSpringService } from '../utils';

export type AppBarLogoShrinkingServiceMeta = {
  src: {
    type: 'LogoShrinkingService',
  },
};

export const name = 'animateLogoShrinking';

export const makeService = makeSpringService(name, 'logoExpanded', 0, false, events.logoExpandingFinished.eventBuilder);

export default makeService;
